import React, { useState } from "react";

import { TypeToledo } from "@at/design-system-foundation";
import { IconArrowRight } from "@at/design-system-icons";
import { Modal, ModalVariant } from "@at/design-system-patterns";
import { dataAttrGUI } from "@at/formatter-utils/lib/data-attr-utils/data-attr-utils";

import { ChargingDataProps } from "../../../../types/chargin-data.types";
import { useTracking } from "../../../../utils/tracking/use-tracking";
import { Arrow } from "../../../buying-safely/buying-safely.styles";
import { VehicleCheckLabel } from "../../vehicle-check/vehicle-check.styles";
import { VehicleInformationLink } from "../../vehicle-information.styles";
import { VehicleInformation } from "../charging.styles";
import { HoursPerWeekToCharge } from "../hours-per-week-to-charge";

const HowOftenModal = ({ chargingData }: ChargingDataProps) => {
  const [visible, setVisible] = useState(false);
  const { trackModalEvent } = useTracking();

  if (!chargingData || chargingData.chargers?.length === 0) return <></>;
  return (
    <VehicleInformation>
      <VehicleInformationLink
        {...{ [dataAttrGUI]: "how-often-to-charge" }}
        data-testid="how-often-to-charge-link"
        onClick={() => {
          setVisible(true);
        }}
      >
        <VehicleCheckLabel>
          <TypeToledo as="span" weight="400">
            How often will I need to charge?
          </TypeToledo>
        </VehicleCheckLabel>
        <Arrow>
          <IconArrowRight title=" " additionalClass="right-arrow" />
        </Arrow>
      </VehicleInformationLink>
      <Modal
        isShowing={visible}
        hasBackLink={false}
        closeText="Back"
        variation={ModalVariant.SLIDE}
        trackingCallback={({ modalAction }) => {
          trackModalEvent({
            trackingLabel: "how-often-to-charge",
            modalAction,
          });
        }}
        hideFn={() => setVisible(false)}
      >
        <HoursPerWeekToCharge chargers={chargingData?.chargers} />
      </Modal>
    </VehicleInformation>
  );
};

export default HowOftenModal;
